import { useContext } from 'react'

import { ConnectedUserContext } from '../components'

const INTERNAL_DOMAIN_NAME = ['goto.com', 'logmein.com', 'lmiprod.com']

interface UseGtcBillingFeatures {
  isInternalUser: boolean
}

const useGtcBillingFeatures = (): UseGtcBillingFeatures => {
  const userContext = useContext(ConnectedUserContext)

  const isInternalUser = (email: string): boolean => INTERNAL_DOMAIN_NAME.some((domain) => email.endsWith(domain))

  return {
    isInternalUser: isInternalUser(userContext?.email || ''),
  }
}

export default useGtcBillingFeatures
